const routes = [
    {
        path: "/prices",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission:'productprice_index'
        }
    }
];

export default routes;
